module.exports = __webpack_public_path__ + "static/img/search-button.153eee05.svg";